import { observable, computed, action, makeObservable } from 'src_common/common/mobx-wrapper';
import { FormModel } from './FormModel';
import { ConversionFn, Result, ResultValue } from './type';

/**
 * @deprecated - Please use src_common/common/mobx-utils/Form2/FormInputState.ts
 */
export class FormInputState<K> {
    private readonly initValue: K;
    @observable private innerValue: K;
    @observable private isVisitedInner: boolean;

    public constructor(value: K, isVisited: boolean) {
        this.initValue = value;
        this.innerValue = value;
        this.isVisitedInner = isVisited;
        makeObservable(this);
    }

    @action public setValue(value: K): void {
        this.innerValue = value;
    }

    @action public setAsVisited(): void {
        this.isVisitedInner = true;
    }

    public toModel(): FormModel<K> {
        return this.map((item: K): Result<K> => new ResultValue(item));
    }

    public map<C>(conv: ConversionFn<K, C>): FormModel<C> {
        return new FormModel(this, (): Result<C> => conv(this.value));
    }

    @computed public get value(): K {
        return this.innerValue;
    }

    @computed public get modifiedStatus(): boolean {
        return this.initValue !== this.innerValue;
    }

    public get isVisited(): boolean {
        return this.isVisitedInner;
    }

    @action public reset(): void {
        this.innerValue = this.initValue;
        this.isVisitedInner = false;
    }
}
